import {
  Box,
  Button,
  Grid,
  Heading,
  PageContainer,
  Typography,
} from "@sidelinesports/fan-design-system";
import { useState } from "react";
import { useParams, useSearchParams } from "react-router";
import { useLocalStorage } from "react-use";
import { Page } from "../../analytics/Page.tsx";
import { useConfig } from "../../hooks/use-config";
import { NoTenantMessage } from "./components";
import { generateRandomUserId } from "./generate-random-user-id";
import { useAfterLoginRedirectUrl, useSetTenant } from "./hooks";
import { Login } from "./Login";

export const DemoLoginPage = () => {
  const config = useConfig();
  const routeParams = useParams<{ tenant?: string }>();
  const [searchParams] = useSearchParams();
  const [isLoggingIn, login] = useState(false);

  const tenant =
    routeParams.tenant ?? searchParams.get("tenant") ?? config.tenant;

  const afterLoginRedirectUrl = useAfterLoginRedirectUrl();

  useSetTenant(tenant);

  const [externalId, setExternalId] = useLocalStorage(
    `RANDOM_DEMO_USER_ID::${tenant}`,
    generateRandomUserId(),
  );

  if (!tenant) {
    return <NoTenantMessage />;
  }

  if (isLoggingIn && externalId) {
    return (
      <Login
        externalId={externalId}
        provider="DEMO"
        redirectTo={afterLoginRedirectUrl}
      />
    );
  }

  return (
    <Page name="DemoLogin">
      <PageContainer style={{ display: "flex" }}>
        <Box background="white" m="auto" p={40} borderRadius={8} maxW="30rem">
          <Grid gap="2.5rem">
            <Heading level={1}>Welcome to Pick 3</Heading>
            <Grid gap="1rem">
              <Typography size="md">
                You are about to demo Pick 3. You have been assigned a random
                user ID: <strong>{externalId}</strong>. This ID will be used to
                track your progress and save your data.
              </Typography>
              <Button variant="action" onClick={() => login(true)}>
                Start Playing
              </Button>
            </Grid>
            <Grid gap="0.5rem">
              <Typography size="md" color="muted">
                If you're returning and would like to enter as a new user, tap
                the button below to get a new user ID.
              </Typography>
              <Button
                variant="outline"
                onClick={() => setExternalId(generateRandomUserId())}
              >
                Get a New User ID
              </Button>
            </Grid>
          </Grid>
        </Box>
      </PageContainer>
    </Page>
  );
};
